import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Promo-ED forms
   */
  {
    label: 'Please select your preference of ED medication:',
    field: 'pedPref',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'sildenafil',
          value: 'Sildenafil'
        },
        {
          key: 'tadalafil',
          value: 'Tadalafil'
        }
      ]
    }
  }
];

export default questionsModels;
